import React from 'react'
import {
  Box, Link, Typography, useTheme, Theme,
} from '@mui/material'

const Footer: React.FC = () => {
  const theme: Theme = useTheme()
  return (
    <Box sx={{
      position: 'sticky',
      bottom: 0,
      width: '100%',
      display: 'flex',
      backgroundColor: theme.palette.primary.main,
      padding: '20px',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#ffffff',
      textTransform: 'uppercase',
    }}
    >
      <Typography
        variant='caption'
      >{'© 2025 | '}<Link
        href='https://www.3m5.de/impressum'
        sx={{ cursor: 'pointer' }}
        underline='hover'
        key='imprint'
        color='#ffffff'
        >
        Impressum
                    </Link> | <Link
          href='https://www.3m5.de/datenschutz'
          sx={{ cursor: 'pointer' }}
          underline='hover'
          key='security'
          color='#ffffff'
                  >
          Datenschutzerklärung
                  </Link>
      </Typography>
    </Box>
  )
}
export default Footer
